const { __ } = wp.i18n;
const { registerBlockType } = wp.blocks;

const { InspectorControls } = wp.blockEditor;

const { PanelBody, SelectControl, Disabled, ToggleControl, TextControl } = wp.components;
const { serverSideRender: ServerSideRender } = wp;
import {
	__experimentalPanelColorGradientSettings as PanelColorGradientSettings
} from '@wordpress/block-editor';
import { __experimentalUnitControl as UnitControl } from '@wordpress/components';

import icons from "../../../icons.js";
/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
registerBlockType("wp-apidae/related", {
	title: __("Fiches liées", "wp-apidae"), // Block title.
	description: __("Affiche les fiches liées.", "wp-apidae"),
	icon: {
		foreground: '#EFB114',
		background: '#331F5B',
		src: icons.link
	},
	supports: {
    align: ['full','wide'],
  },
	example: {
  },
	attributes: {
		columns: {
			type: 'number',
			default: 1,
		},
		show_title: {
			type: "boolean",
			default: true,
		},
		field_tag: {
			type: 'string',
			default: 'h2',
		},
		align: {
			type: 'string',
			default: '',
		},
		background_color: {
			type: 'string',
			default: '',
		},
		background_gradient: {
			type: 'string',
			default: '',
		},
		content_width: {
			type: 'string',
		},
	},
	edit: class extends wp.element.Component {
		render() {
			const props = this.props;
			const attributes = props.attributes;

			var template = window.WpApidaeTemplateData.settings;
			const fieldsTags          = window.WpApidaeTemplateData.fieldsTags;

			return [
				<InspectorControls key={"inspector"}>
					<PanelBody title={__("Options")}>
						<ToggleControl
								label={ __( 'Afficher un titre de section' ) }
								checked={ attributes.show_title }
								onChange={ () => {
									props.setAttributes({ show_title: ! attributes.show_title });
								} }
							/>
							{ true === attributes.show_title &&
							<SelectControl
							label={ __( 'Balise à utiliser' ) }
							value={ attributes.field_tag }
							options={fieldsTags}
							onChange={ newValue => {
								props.setAttributes({
									field_tag: newValue,
								});
							}}
						/>}
						<TextControl
								type="number"
								label={__("Nombre de colonnes")}
								value={attributes.columns}
								min={`1`}
								max={`4`}
								onChange={(newValue) => {
									props.setAttributes({ columns: Number(newValue) });
								}}
							/>
						</PanelBody>
						<PanelBody title={__("Affichage")}>
						<div class="block-editor-hooks__layout-controls">
							<div class="block-editor-hooks__layout-controls-unit">
								<UnitControl
									label={__("Largeur max. contenu")}
									labelPosition={'side'}
									value={ attributes.content_width }
									units={[
										{ value: 'px', label: 'px' },
										{ value: '%', label: '%' },
										{ value: 'em', label: 'em'},
										{ value: 'rem', label: 'rem' },
										{ value: 'vw', label: 'vw' },
									]}
									onChange={ newValue => {
										props.setAttributes({
											content_width: newValue,
										});
									}}
								/>
							</div>
						</div>
						</PanelBody>
						<PanelColorGradientSettings
					title={ __("Colors") }
					settings={ [
					{
						colorValue: attributes.background_color,
						gradientValue: attributes.background_gradient,
						label:__("Arrière-plan"),
						onColorChange:(newValue) => props.setAttributes({background_color: newValue }),
						onGradientChange:(newValue) => props.setAttributes({background_gradient: newValue }),
					} ] }
				>
				</PanelColorGradientSettings>
				</InspectorControls>,
				<Disabled>
					<ServerSideRender
						block="wp-apidae/related"
						attributes={attributes}
						urlQueryArgs={{
							settings: template,
						}}
					/>
				</Disabled>,
			];
		}
	},

	save: () => {
		return null;
	},
});
